import { createAction } from "redux-act";

export const receiveCalculationData = createAction();
export const receiveFieldMetadata = createAction();
export const updateUser = createAction();
export const updateFundsRequested = createAction();